import * as React from "react";

function SvgPsr(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 56 56" fill="none" {...props}>
      <path
        d="M20.5 38l-3.75 5L13 38h2.5v-6.25H18V38h2.5zM35.5 18l3.75-5L43 18h-2.5v6.25H38V18h-2.5zM15.5 23H13v-3.125L19.875 13H23v2.5h-2.5l-5 5V23z"
        fill="#fff"
      />
      <path d="M19.25 23L23 19.25h13.75v17.5h-17.5V23z" fill="#fff" />
      <circle cx={28} cy={28} r={27} stroke="#fff" />
    </svg>
  );
}

export default SvgPsr;
